import React, { useState } from 'react';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F',GREEN='#22C55E',PURPLE='#7C3AED';
const s = {
  btn:{padding:'11px 22px',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer',border:'none',fontFamily:"'Syne',sans-serif"},
  input:{background:'#F4F4F4',border:'0.5px solid #D3D1C7',borderRadius:'9px',padding:'10px 13px',fontSize:'13px',width:'100%',fontFamily:"'Syne',sans-serif",outline:'none',boxSizing:'border-box'},
  label:{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'4px',display:'block'},
};

const api = async (endpoint, options={}) => {
  const token = localStorage.getItem('token');
  const res = await fetch(`/api${endpoint}`, {
    headers:{'Content-Type':'application/json',...(token?{Authorization:'Bearer '+token}:{})},
    ...options
  });
  return res.json();
};

export default function AddVehicle({ onClose, onAdded }) {
  const [mode, setMode] = useState(null); // null | 'scan' | 'manual'
  const [uploading, setUploading] = useState(false);
  const [ocrRunning, setOcrRunning] = useState(false);
  const [ocrData, setOcrData] = useState(null);
  const [msg, setMsg] = useState('');
  const [form, setForm] = useState({
    plate_number:'', brand:'', model:'', year:'', fuel_type:'Diesel', vin:'', engine_cc:'', emission_norm:''
  });

  const uploadAndOCR = async (file) => {
    setUploading(true);
    setMsg('⏳ Se încarcă actul mașinii...');

    // Creare vehicul temporar
    const vehicleData = await api('/vehicles', {
      method:'POST',
      body: JSON.stringify({ plate_number:'', brand:'', model:'', year:null, fuel_type:'Diesel' })
    });
    if (!vehicleData.vehicle) { setMsg('✗ Eroare creare dosar'); setUploading(false); return; }
    const vehicleId = vehicleData.vehicle.id;

    // Upload fișier
    const fd = new FormData();
    fd.append('file', file);
    fd.append('vehicle_id', vehicleId);
    fd.append('doc_type', 'talon');
    const token = localStorage.getItem('token');
    const uploadRes = await fetch('/api/documents/upload', {
      method:'POST', headers:{Authorization:'Bearer '+token}, body:fd
    });
    const uploadData = await uploadRes.json();
    if (!uploadData.document) { setMsg('✗ Eroare upload'); setUploading(false); return; }

    setUploading(false);
    setOcrRunning(true);
    setMsg('🤖 Se extrag datele prin AI... (10-20 secunde)');

    // OCR
    const ocrResult = await api('/ocr/extract', {
      method:'POST',
      body: JSON.stringify({ document_id: uploadData.document.id, vehicle_id: vehicleId })
    });

    if (ocrResult.success && ocrResult.data) {
      const d = ocrResult.data;
      // Actualizam vehiculul cu datele OCR
      await api(`/vehicles/${vehicleId}`, {
        method:'PUT',
        body: JSON.stringify({
          plate_number: d.plate_number || '',
          brand: d.brand || '',
          model: d.model || '',
          year: d.year || '',
          vin: d.vin || '',
          engine_cc: d.engine_cc || '',
          fuel_type: d.fuel_type || 'Diesel',
          emission_norm: d.emission_norm || '',
        })
      });
      setOcrData({ ...d, vehicle_id: vehicleId });
      setMsg('✓ Dosar creat automat din act!');
    } else {
      setOcrData({ vehicle_id: vehicleId });
      setMsg('⚠ OCR indisponibil — dosarul a fost creat. Completați datele manual din pagina mașinii.');
    }
    setOcrRunning(false);
    setTimeout(() => { onAdded(); onClose(); }, 2000);
  };

  const addManual = async () => {
    if (!form.plate_number && !form.vin) {
      setMsg('✗ Introduceți numărul de înmatriculare sau VIN!'); return;
    }
    const cleanForm = {...form, year: form.year ? parseInt(form.year) : null, engine_cc: form.engine_cc ? parseInt(form.engine_cc) : null};
    const data = await api('/vehicles', { method:'POST', body: JSON.stringify(cleanForm) });
    if (data.vehicle) { onAdded(); onClose(); }
    else setMsg(data.error || 'Eroare la adăugare');
  };

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.6)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div style={{background:'#fff',borderRadius:'16px',width:'100%',maxWidth:'480px',overflow:'hidden'}}>

        {/* Header */}
        <div style={{background:DARK,padding:'16px 20px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div style={{color:'#fff',fontWeight:800,fontSize:'15px'}}>
            {mode===null ? '🚗 Adaugă mașină' : mode==='scan' ? '📸 Scanează actul' : '✍️ Adaugă manual'}
          </div>
          <button onClick={onClose} style={{...s.btn,background:'rgba(255,255,255,.1)',color:'#fff',padding:'5px 12px',fontSize:'12px'}}>✕</button>
        </div>

        <div style={{padding:'24px'}}>
          {msg && (
            <div style={{background:msg.includes('✓')?'#DCFCE7':msg.includes('🤖')||msg.includes('⏳')?'#EDE9FE':msg.includes('⚠')?'#FEF3DC':'#FEE2E2',borderRadius:'8px',padding:'10px',fontSize:'12px',color:msg.includes('✓')?'#15803D':msg.includes('🤖')||msg.includes('⏳')?PURPLE:msg.includes('⚠')?'#D97706':'#B91C1C',marginBottom:'14px'}}>
              {msg}
            </div>
          )}

          {/* SELECTIE MOD */}
          {mode === null && (
            <div>
              <div style={{fontSize:'13px',color:'#666',marginBottom:'20px',textAlign:'center'}}>
                Cum vrei să adaugi mașina?
              </div>
              <div style={{display:'flex',flexDirection:'column',gap:'12px'}}>
                <label style={{border:`2px dashed ${GOLD}`,background:'#FEF3DC',borderRadius:'14px',padding:'20px',textAlign:'center',cursor:'pointer',display:'block'}}>
                  <div style={{fontSize:'36px',marginBottom:'8px'}}>📸</div>
                  <div style={{fontWeight:800,fontSize:'15px',marginBottom:'4px'}}>Scanează actul mașinii</div>
                  <div style={{fontSize:'12px',color:'#888',marginBottom:'12px'}}>Fotografiază talonul sau actele — datele se completează automat prin AI</div>
                  <div style={{...s.btn,background:GOLD,color:DARK,display:'inline-block'}}>📎 Selectează fișier / Fotografiază</div>
                  <input type="file" style={{display:'none'}} accept=".jpg,.jpeg,.png,.pdf,.heic,.webp"
                    onChange={e=>{ if(e.target.files[0]) { setMode('scan'); uploadAndOCR(e.target.files[0]); } e.target.value=''; }}/>
                </label>

                <button onClick={()=>setMode('manual')} style={{border:'1.5px solid #D3D1C7',background:'#fff',borderRadius:'14px',padding:'20px',textAlign:'center',cursor:'pointer',width:'100%'}}>
                  <div style={{fontSize:'36px',marginBottom:'8px'}}>✍️</div>
                  <div style={{fontWeight:800,fontSize:'15px',marginBottom:'4px'}}>Adaugă manual</div>
                  <div style={{fontSize:'12px',color:'#888'}}>Completează datele mașinii manual</div>
                </button>
              </div>
            </div>
          )}

          {/* MOD SCAN */}
          {mode === 'scan' && (
            <div style={{textAlign:'center',padding:'20px 0'}}>
              {uploading && (
                <div>
                  <div style={{fontSize:'48px',marginBottom:'16px'}}>📤</div>
                  <div style={{fontWeight:700,marginBottom:'8px'}}>Se încarcă actul...</div>
                </div>
              )}
              {ocrRunning && (
                <div>
                  <div style={{fontSize:'48px',marginBottom:'16px'}}>🤖</div>
                  <div style={{fontWeight:700,marginBottom:'8px'}}>AI procesează actul...</div>
                  <div style={{fontSize:'12px',color:'#888'}}>Extrage datele din document</div>
                </div>
              )}
              {ocrData && (
                <div>
                  <div style={{fontSize:'48px',marginBottom:'12px'}}>✅</div>
                  <div style={{fontWeight:800,fontSize:'16px',marginBottom:'8px',color:GREEN}}>Dosar creat!</div>
                  <div style={{fontSize:'14px',fontWeight:700,marginBottom:'4px'}}>
                    {ocrData.plate_number || ocrData.vin || 'Vehicul nou'}
                  </div>
                  <div style={{fontSize:'12px',color:'#666'}}>
                    {[ocrData.brand, ocrData.model, ocrData.year].filter(Boolean).join(' ')}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* MOD MANUAL */}
          {mode === 'manual' && (
            <div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'14px'}}>
                <div style={{gridColumn:'1/-1'}}>
                  <label style={s.label}>Nr. înmatriculare</label>
                  <input style={s.input} placeholder="IS33AUT" value={form.plate_number}
                    onChange={e=>setForm({...form,plate_number:e.target.value.toUpperCase()})}/>
                </div>
                <div>
                  <label style={s.label}>Marcă</label>
                  <input style={s.input} placeholder="Dacia" value={form.brand}
                    onChange={e=>setForm({...form,brand:e.target.value})}/>
                </div>
                <div>
                  <label style={s.label}>Model</label>
                  <input style={s.input} placeholder="Logan" value={form.model}
                    onChange={e=>setForm({...form,model:e.target.value})}/>
                </div>
                <div>
                  <label style={s.label}>An fabricație</label>
                  <input style={s.input} placeholder="2022" type="number" value={form.year}
                    onChange={e=>setForm({...form,year:e.target.value})}/>
                </div>
                <div>
                  <label style={s.label}>Combustibil</label>
                  <select style={s.input} value={form.fuel_type} onChange={e=>setForm({...form,fuel_type:e.target.value})}>
                    <option>Diesel</option><option>Benzină</option><option>Hibrid</option><option>Electric</option>
                  </select>
                </div>
                <div style={{gridColumn:'1/-1'}}>
                  <label style={s.label}>VIN / Serie șasiu</label>
                  <input style={s.input} placeholder="WVWZZZ1KZ..." value={form.vin}
                    onChange={e=>setForm({...form,vin:e.target.value.toUpperCase()})}/>
                </div>
              </div>
              <div style={{display:'flex',gap:'8px'}}>
                <button onClick={()=>setMode(null)} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7',flex:1}}>
                  ← Înapoi
                </button>
                <button onClick={addManual} style={{...s.btn,background:GOLD,color:DARK,flex:2}}>
                  Adaugă mașina →
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
